/**
 * @param str {String} - исходная строка
 * @param count {Number} - количество символов, которые нужно отрезать с конца
 * @return {String} - обрезанная строка на count-символов с ... в конце
 */
export function hideLastDigits(str: string, count: number): string {
  return str.slice(0, -1 * count).concat('…');
}

/**
 * Форматирование номера телефона 79881723344 => +7 988 172-33-44
 * @param phone номер телефона в формате 79881723344
 */
export function parsePhoneNumber(phone: string): string {
  return `+${phone.substr(0, 1)} ${phone.substr(1, 3)} ${phone.substr(4, 3)}-${phone.substr(7, 2)}-${phone.substr(
    9,
    2,
  )}`;
}
